<template>
  <a class="icon" href="/account/promotions">
    <ui-badge
      :text="COUPONS_COUNT"
      color="#F34744"
      max-width="50"
    />
    <f-sprite-icon :icon-link="$options.icons.IconNotifications.id" />
  </a>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

/* Icons */
import IconNotifications from '../../assets/icons/notifications.svg';

export default {
  name: 'control-promotions',

  icons: {
    IconNotifications,
  },

  computed: {
    ...mapGetters({
      COUPONS: 'user/coupons',
      COUPONS_COUNT: 'user/couponsCount'
    }),
  },

  mounted() {
    this.LOAD_COUPONS();
  },

  methods: {
    ...mapActions({
      LOAD_COUPONS: 'user/loadCoupons'
    })
  }
}
</script>
